import { render, staticRenderFns } from "./NewWork..vue?vue&type=template&id=665a4350&scoped=true"
import script from "./NewWork..vue?vue&type=script&lang=js"
export * from "./NewWork..vue?vue&type=script&lang=js"
import style0 from "./NewWork..vue?vue&type=style&index=0&id=665a4350&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "665a4350",
  null
  
)

export default component.exports